/**
 * user behavior
 * author: leo
 * date: 2024-02-28
 */

function generateRandomId() {
    return Math.random().toString(36).substring(2);
}

function generateSessionId() {
    var sessionId = sessionStorage.getItem("heychicSessionId");
    if (!sessionId) {
        sessionId = generateRandomId();
        sessionStorage.setItem("heychicSessionId", sessionId);
    }
    return sessionId;
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
}

function handleEvent() {
    const data = {
        ua: navigator.userAgent,
        u_w: screen.width,
        u_h: screen.height,
        customerId: customerLoginId,
        page: window.location.href,
        time: new Date().getTime(),
        ref: document.referrer,
        clientId: localStorage.getItem("clientId"),
        csid: heychicSessionId,
        cartId: cartId,
        cpid: cpid,
        tzo: new Date().getTimezoneOffset(),
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // 'shop_id':'66793275449',//测试
        'shop_id':'59363262637' //正式

    };
    const queryString = Object.keys(data)
        .map((key) => key + "=" + encodeURIComponent(data[key]))
        .join("&");
    new Image().src =
        // "https://dev.api.shop.heychic.com.au/analysis/log?" + queryString;
        // `https://test-user-api.heychic.net/web/analysis/log?` + queryString; //测试
        `https://user-api.heychic.net/web/analysis/log?` + queryString; //正式
}

var customerLoginId;
if (ShopifyAnalytics.meta.page.customerId) {
    customerLoginId = ShopifyAnalytics.meta.page.customerId;
} else {
    customerLoginId = "";
}
var cartId = getCookie("cart");
var heychicSessionId = generateSessionId();
var cpid = '';
handleEvent();

var addButton = document.getElementById("product-add-to-cart");
if (addButton) {
    addButton.addEventListener("click", function () {
        cpid = ShopifyAnalytics.meta.product.id;
        if (cpid) {
            handleEvent();
        }
        console.log("click add to cart", cpid);
    });
}